
export class stockist {
    constructor() {
        this.Init();
    }

    Init() {
        let MainFunc = this;
        // Stockist filter buttons
        jQuery('.filter-btn.region-filter').on('click', function () {
            jQuery(this).toggleClass('active');
            MainFunc.FilterList();
        });

        // Stockist filter search
        jQuery('.stockist-search').on("keyup", function () {
            MainFunc.FilterList();
        });
    }

    FilterList() {

        var value = (jQuery('.stockist-search').val() as String).toLowerCase();
        var activeRegionFilters = [];

        jQuery(".filter-btn.active").each(function () {
            activeRegionFilters.push(jQuery(this).data("region").toLowerCase());
        });


        jQuery(".stockist-grid .stockist").each(function () {

            var isRelevantSearchResult = jQuery(this).text().toLowerCase().indexOf(value) > -1;

            if (jQuery(this).text().length == 0) {
                isRelevantSearchResult = true;
            }

            if (activeRegionFilters.indexOf(jQuery(this).data("region")) == -1) {
                isRelevantSearchResult = false;
            }

            jQuery(this).toggle(isRelevantSearchResult);

        });
    }
}